import React from 'react'
import PropTypes from 'prop-types'
import { MetaTags } from "react-meta-tags"
import { Col, Container, Row } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"

import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import { addNewProductStockIn } from "../../store/product-stock-in/actions"
import ProductStockInForm from "../../containers/product-stock-in/ProductStockInForm"

const AddNewProductStockIn = props => {
  const { addNewProductStockIn, history } = props

  const handleOnSubmit = (data) => {
    addNewProductStockIn(data)
    history.push(`/product-stock-in`)
  }

  const handleOnCancel = () => {
    history.push(`/product-stock-in`)
  }

  return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Product Stock In | CR TechSoft</title>
          </MetaTags>
          <Container fluid>
            <Breadcrumbs
                title="Home"
                backLink={ `/product-stock-in` }
                breadcrumbItem={ `Add New Product Stock In` }
            />
            <Row>
              <Col md={ 12 }>
                <ProductStockInForm onSubmit={ handleOnSubmit } onCancel={ handleOnCancel }/>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
  )
}

AddNewProductStockIn.propTypes = {
  addNewProductStockIn: PropTypes.func,
  match: PropTypes.object,
  history: PropTypes.object,
}

const mapStateToProps = ({ productStockIn }) => {
  return productStockIn
}

export default withRouter(
    connect(mapStateToProps, {
      addNewProductStockIn,
    })(AddNewProductStockIn)
)
